import {
  GET_COMPUTE_DATA_API,
  DOWNLOAD_COMPUTE_EXCEL_API,
  TOTAL_SUM_COMPUTE_DATA
} from '../endpoints/apiEndpoints'
import {
  buildRequestHeader,
  handleErrorResponse,
  handleRequestFailure,
  handleSuccessResponse,
  urlBuilder,
} from './apiUtils'

export const getComputeData = async (payload) => {
  const url = urlBuilder(GET_COMPUTE_DATA_API)
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const downloadComputeExcel = async (payload,tanUuid) => {
  const url = urlBuilder(DOWNLOAD_COMPUTE_EXCEL_API,{tanUuid})
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}


export const getTotalSum = async(payload,isCompute='true') => {
  const url = urlBuilder(TOTAL_SUM_COMPUTE_DATA,{isCompute})
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}
